import flatten from 'lodash-es/flatten'

import { EMPTY_LIST } from '../constants/common'
import {
  MENU_ABOUT_ITEM,
  MENU_BUILDING_GROUP_ITEM,
  MENU_BUILDING_ITEM,
  MENU_CHAT_ITEM,
  MENU_DOCUMENT_ITEM,
  MENU_DOCUMENT_ITEM_DWELLER,
  MENU_DOCUMENT_STAPLING_ITEM,
  MENU_EMAIL_ITEM,
  MENU_FAQ_ITEM,
  MENU_FLAT_ITEM,
  MENU_IDWELL_TO_IDWELL_ITEM,
  MENU_INHABITANT_ITEM,
  MENU_MARKETPLACE_ITEM,
  MENU_POST_ITEM,
  MENU_PROVIDERS_ITEM,
  MENU_RENTAL_PORTAL_ITEM,
  MENU_SERVICE_REQUEST_ITEM,
  MENU_TASK_ITEM,
} from '../constants/menu'
import {
  SETTINGS_MENU_ACTIVITY_ITEM,
  SETTINGS_MENU_AUTH_ITEM,
  SETTINGS_MENU_AUTOMATED_ITEM,
  SETTINGS_MENU_BOT_ITEM,
  SETTINGS_MENU_BUTTON_BACK_ITEM,
  SETTINGS_MENU_COLOR_THEME_ITEM,
  SETTINGS_MENU_COMPANY_ITEM,
  SETTINGS_MENU_CONFIG_ITEM,
  SETTINGS_MENU_EMAIL_ITEM,
  SETTINGS_MENU_EMAIL_NEW_ITEM,
  SETTINGS_MENU_EPOST_BILLING_ITEM,
  SETTINGS_MENU_ERP_ITEM,
  SETTINGS_MENU_GOOGLE_ITEM,
  SETTINGS_MENU_IDWELL_ITEM,
  SETTINGS_MENU_IMPORT_DATA_ITEM,
  SETTINGS_MENU_LABELS_ITEM,
  SETTINGS_MENU_NOTIFICATIONS_ITEM,
  SETTINGS_MENU_PERSONAL_ITEM,
  SETTINGS_MENU_PROCESS_STRUCTURE_ITEM,
  SETTINGS_MENU_TARIFFS_LIMITS_ITEM,
  SETTINGS_MENU_TEXT_TEMPLATE_ITEM,
  SETTINGS_MENU_USER_MANAGMENT_ITEM,
} from '../constants/menu.settings'
import {
  ROUTE_UI_SECTION_NAME,
  ROUTE_UI_SECTION_NAME_RENTAL_PORTAL,
} from '../constants/route'
import { LOCAL_STORAGE_MENU_COLLAPSED_KEY } from '../constants/storage'
import {
  ADMIN_USER_ROLE,
  DWELLER_USER_ROLE,
  LANDLORD_USER_ROLE,
  MANAGER_USER_ROLE,
  WORKER_USER_ROLE,
} from '../constants/user'

import { getSectionCanViewPermission } from './common'
import { withRentalPortalMockSections } from './rentalPortalMock'
import { getStorageSerializedItem, setStorageSerializedItem } from './storage'
import { isUnconfirmed } from './user'

function getMenuItemBySectionsPermissions({
  menuItem,
  sectionName,
  sectionsPermissions,
}) {
  const canView = getSectionCanViewPermission(sectionsPermissions, sectionName)

  return canView ? [menuItem] : EMPTY_LIST
}

function getMenuItemAboutUs({ sectionsPermissions }) {
  return getMenuItemBySectionsPermissions({
    menuItem: MENU_ABOUT_ITEM,
    sectionName: ROUTE_UI_SECTION_NAME.aboutUs,
    sectionsPermissions,
  })
}

function getMenuItemDocuments({ sectionsPermissions }) {
  return getMenuItemBySectionsPermissions({
    menuItem: MENU_DOCUMENT_ITEM,
    sectionName: ROUTE_UI_SECTION_NAME.documents,
    sectionsPermissions,
  })
}

function getMenuItemDwellerDocuments({ sectionsPermissions }) {
  return getMenuItemBySectionsPermissions({
    menuItem: MENU_DOCUMENT_ITEM_DWELLER,
    sectionName: ROUTE_UI_SECTION_NAME.documentsDweller,
    sectionsPermissions,
  })
}

function getMenuItemChats({ sectionsPermissions }) {
  return getMenuItemBySectionsPermissions({
    menuItem: MENU_CHAT_ITEM,
    sectionName: ROUTE_UI_SECTION_NAME.chats,
    sectionsPermissions,
  })
}

function getMenuItemFaq({ sectionsPermissions }) {
  return getMenuItemBySectionsPermissions({
    menuItem: MENU_FAQ_ITEM,
    sectionName: ROUTE_UI_SECTION_NAME.faq,
    sectionsPermissions,
  })
}

function getMenuItemRentalPortal({ sectionsPermissions }) {
  return getMenuItemBySectionsPermissions({
    menuItem: MENU_RENTAL_PORTAL_ITEM,
    sectionName: ROUTE_UI_SECTION_NAME_RENTAL_PORTAL.root,
    sectionsPermissions: withRentalPortalMockSections(sectionsPermissions),
  })
}

function getMenuItemMarketPlace(permissions) {
  return permissions.is_marketplace_available
    ? [[MENU_MARKETPLACE_ITEM]]
    : EMPTY_LIST
}

export function getMenuActiveItem(items, pathname) {
  return flatten(items).find(
    item =>
      pathname === `/${item.to}` ||
      pathname === `/${item.to}/` ||
      (item.withNestedRoutes && pathname.startsWith(`/${item.to}/`))
  )
}

export function getDwellerMenuItems(permissions) {
  return [
    [
      MENU_POST_ITEM,
      ...getMenuItemChats(permissions),
      MENU_SERVICE_REQUEST_ITEM,
      ...getMenuItemDwellerDocuments(permissions),
    ],
    [MENU_FLAT_ITEM, MENU_BUILDING_ITEM],
    ...getMenuItemMarketPlace(permissions),
    [...getMenuItemFaq(permissions), ...getMenuItemAboutUs(permissions)],
  ].filter(item => item.length > 0)
}

export function getAdminMenuItems(permissions, uiSections) {
  return [
    [
      MENU_POST_ITEM,
      MENU_EMAIL_ITEM,
      ...getMenuItemChats(permissions),
      MENU_SERVICE_REQUEST_ITEM,
      ...(permissions.is_connected_requests_visible
        ? [MENU_IDWELL_TO_IDWELL_ITEM]
        : EMPTY_LIST),
      MENU_TASK_ITEM,
      ...getMenuItemDocuments(permissions),
      ...(uiSections[ROUTE_UI_SECTION_NAME.docFlows]
        ? [MENU_DOCUMENT_STAPLING_ITEM]
        : EMPTY_LIST),
    ],
    [
      MENU_INHABITANT_ITEM,
      MENU_FLAT_ITEM,
      MENU_BUILDING_ITEM,
      MENU_BUILDING_GROUP_ITEM,
      MENU_PROVIDERS_ITEM,
      ...getMenuItemRentalPortal(permissions),
    ],
    ...getMenuItemMarketPlace(permissions),
    [...getMenuItemFaq(permissions), ...getMenuItemAboutUs(permissions)],
  ]
}

export function getManagerMenuItems(permissions, uiSections) {
  return [
    [
      MENU_POST_ITEM,
      MENU_EMAIL_ITEM,
      ...getMenuItemChats(permissions),
      MENU_SERVICE_REQUEST_ITEM,
      ...(permissions.is_connected_requests_visible
        ? [MENU_IDWELL_TO_IDWELL_ITEM]
        : EMPTY_LIST),
      MENU_TASK_ITEM,
      ...getMenuItemDocuments(permissions),
      ...(uiSections[ROUTE_UI_SECTION_NAME.docFlows]
        ? [MENU_DOCUMENT_STAPLING_ITEM]
        : EMPTY_LIST),
    ],
    [
      MENU_INHABITANT_ITEM,
      MENU_FLAT_ITEM,
      MENU_BUILDING_ITEM,
      MENU_BUILDING_GROUP_ITEM,
      MENU_PROVIDERS_ITEM,
      ...getMenuItemRentalPortal(permissions),
    ],
    ...getMenuItemMarketPlace(permissions),
    [...getMenuItemFaq(permissions), ...getMenuItemAboutUs(permissions)],
  ]
}

// A worker reaches the app only through a shared-request magic link and is locked
// to that single request. The service-requests entry is surfaced so it highlights
// while they view the request (it matches the `requests/…` route), but `blocked`
// stops the click so it never opens the list (a 404 for a worker).
// `alwaysAvailable` keeps it an internal link so the active match works.
export function getWorkerMenuItems() {
  return [
    [
      {
        ...MENU_SERVICE_REQUEST_ITEM,
        alwaysAvailable: true,
        blocked: true,
      },
    ],
  ]
}

export function getMenuItems({
  permissions,
  sectionsPermissions,
  uiSections,
  ukConfig,
  userData,
  userRole,
}) {
  const allPermissions = {
    ...permissions,
    ...ukConfig,
    isUnconfirmed: isUnconfirmed(userData),
    sectionsPermissions,
  }

  switch (userRole) {
    case DWELLER_USER_ROLE:
    case LANDLORD_USER_ROLE:
      return getDwellerMenuItems(allPermissions)

    case ADMIN_USER_ROLE:
      return getAdminMenuItems(allPermissions, uiSections)

    case MANAGER_USER_ROLE:
      return getManagerMenuItems(allPermissions, uiSections)

    case WORKER_USER_ROLE:
      return getWorkerMenuItems()

    default:
      return EMPTY_LIST
  }
}

export function getAdminSettingsMenuItems({
  isConnectedRequestsVisible,
  isNotificationSettingsVisible,
}) {
  return [
    [SETTINGS_MENU_BUTTON_BACK_ITEM],
    [
      SETTINGS_MENU_PERSONAL_ITEM,
      ...(isNotificationSettingsVisible
        ? [SETTINGS_MENU_NOTIFICATIONS_ITEM]
        : EMPTY_LIST),
      SETTINGS_MENU_COMPANY_ITEM,
      SETTINGS_MENU_COLOR_THEME_ITEM,
      SETTINGS_MENU_TARIFFS_LIMITS_ITEM,
      SETTINGS_MENU_USER_MANAGMENT_ITEM,
      SETTINGS_MENU_TEXT_TEMPLATE_ITEM,
      SETTINGS_MENU_GOOGLE_ITEM,
      SETTINGS_MENU_EMAIL_ITEM,
      SETTINGS_MENU_EMAIL_NEW_ITEM,
      SETTINGS_MENU_AUTH_ITEM,
      SETTINGS_MENU_ERP_ITEM,
      ...(isConnectedRequestsVisible
        ? [SETTINGS_MENU_IDWELL_ITEM]
        : EMPTY_LIST),
      SETTINGS_MENU_IMPORT_DATA_ITEM,
      SETTINGS_MENU_CONFIG_ITEM,
      SETTINGS_MENU_LABELS_ITEM,
      SETTINGS_MENU_BOT_ITEM,
      SETTINGS_MENU_PROCESS_STRUCTURE_ITEM,
      SETTINGS_MENU_ACTIVITY_ITEM,
      SETTINGS_MENU_AUTOMATED_ITEM,
      SETTINGS_MENU_EPOST_BILLING_ITEM,
    ],
  ]
}

export function getDwellerSettingsMenuItems() {
  return [[SETTINGS_MENU_BUTTON_BACK_ITEM], [SETTINGS_MENU_PERSONAL_ITEM]]
}

export function getManagerSettingsMenuItems({ isNotificationSettingsVisible }) {
  return [
    [SETTINGS_MENU_BUTTON_BACK_ITEM],
    [
      SETTINGS_MENU_PERSONAL_ITEM,
      ...(isNotificationSettingsVisible
        ? [SETTINGS_MENU_NOTIFICATIONS_ITEM]
        : EMPTY_LIST),
      SETTINGS_MENU_TEXT_TEMPLATE_ITEM,
      SETTINGS_MENU_EMAIL_ITEM,
      SETTINGS_MENU_EMAIL_NEW_ITEM,
    ],
  ]
}

export function getSettingsMenuItems({
  sectionsPermissions,
  uiSections,
  ukConfig,
  userRole,
}) {
  const isNotificationSettingsVisible =
    uiSections?.[ROUTE_UI_SECTION_NAME.settingsNotifications] &&
    getSectionCanViewPermission(
      sectionsPermissions,
      ROUTE_UI_SECTION_NAME.settingsNotifications
    )

  switch (userRole) {
    case ADMIN_USER_ROLE:
      return getAdminSettingsMenuItems({
        isConnectedRequestsVisible: ukConfig.is_connected_requests_visible,
        isNotificationSettingsVisible,
      })

    case DWELLER_USER_ROLE:
    case LANDLORD_USER_ROLE:
      return getDwellerSettingsMenuItems()

    case MANAGER_USER_ROLE:
      return getManagerSettingsMenuItems({ isNotificationSettingsVisible })

    default:
      return EMPTY_LIST
  }
}

/**
 * Returns stored menu state
 *
 * @returns {boolean}
 */
export function getStoredMenuCollapsedState() {
  return getStorageSerializedItem(LOCAL_STORAGE_MENU_COLLAPSED_KEY, false)
}

/**
 * Store menu state to the local storage
 * @param {boolean} collapsed
 */
export function storeMenuCollapsedState(collapsed) {
  setStorageSerializedItem(LOCAL_STORAGE_MENU_COLLAPSED_KEY, collapsed)
}
